import axios from '@/libs/axiosInstance';

export interface TikTokOAuthRedirectResponse {
  redirectUrl: string;
  state: string;
}

/**
 * Get TikTok OAuth redirect URL from the backend.
 * The backend generates the Business API authorization URL and stores state in Redis.
 */
export const getTikTokOAuthRedirect = async (): Promise<TikTokOAuthRedirectResponse> => {
  const { data } = await axios.get('/dashboard/integrations/tiktok/redirect-url');
  return data;
};
